var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('navigation')],1),_c('div',{staticClass:"col-md-9"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }